// extracted by mini-css-extract-plugin
export default {"level":"DataTable_level__x+4DH"};